/**
 * Type definitions for Animal Groups and Stock Classes
 *
 * This file contains only type definitions and API instances.
 * See: src/model/useAnimalGroupQueries.ts and src/model/useStockClassQueries.ts
 */

export type AnimalGroup = {
  guid: string;
  name: string;
  farm: string;
  postGrazingTarget?: number;
  rotationLength?: number;
  stockClasses: Array<string>;
  color?: string;
  fieldNow?: string;
};
export interface StockClass {
  guid: string;
  name: string;
  animalCount: number;
  consumptionKgPerDay: number;
  averageAnimalWeightKg: number;
  animalGroup: string;
  defaultStockClassName: string | undefined;
  birthingPeriods: Array<string>;
  targetEntryCoverKgM2?: number;
}

// Livestock Unit (LU) conversion rates based on animal type
// Standard: 1 LU = 1 dairy cow (approx 500kg, producing milk)
export const LIVESTOCK_UNIT_CONVERSION: Record<string, number> = {
  DAIRY_COW: 1.0,
  DAIRY_COW_2_KGMS: 1.0,
  SUCKLER_COW: 0.85,
  GROWING_CATTLE: 0.6,
  EWE: 0.15,
  EWE_TWINS: 0.2,
  WEANED_LAMB: 0.1,
};

// Calculate livestock units for a single stock class
export const getStockClassLU = (stockClass: StockClass): number => {
  const conversionRate = stockClass.defaultStockClassName
    ? LIVESTOCK_UNIT_CONVERSION[stockClass.defaultStockClassName] ?? 0.5
    : 0.5; // Default to 0.5 if unknown
  return stockClass.animalCount * conversionRate;
};
